// extracted by mini-css-extract-plugin
module.exports = {"subscriptions__title":"Subscriptions_subscriptions__title__AK9fE"};